import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NzFormatEmitEvent, NzTreeNodeOptions } from 'ng-zorro-antd/tree';
import { EmopTree } from '../../common/EmopTreeData';
import { NzContextMenuService } from 'ng-zorro-antd/dropdown';
@Component({
  selector: 'emop-tree',
  templateUrl: './emop-tree.component.html',
  styleUrls: ['./emop-tree.component.scss']
})
export class EmopTreeComponent implements OnInit {
  defaultCheckedKeys = [];
  defaultSelectedKeys = [];
  defaultExpandedKeys = [];
  @Input() EmopTree: EmopTree;

  @ViewChild('EmopTreeRef') EmopTreeRef;
  @Output() expandChange = new EventEmitter;
  @Output() leftClick = new EventEmitter;
  @Output() check = new EventEmitter;
  constructor(
    private nzContextMenuService: NzContextMenuService
  ) { }

  ngOnInit(): void {
    if (!this.EmopTree) return console.error('请传入EmopTree属性');
    setTimeout(() => {
      this.EmopTree.ref = this.EmopTreeRef;
    }, 0);
  }
  /**
   * 点击事件回调函数
   * @param data 点击事件的数据(当函数内部调用该函数时,data中应携带isFn属性)
   */
  nzClick(data: any): void {
    if (data.isFn) {
      let resultObj = {
        data,
        selected: true,
        node: data.node
      };
      delete resultObj.data.node;
      delete data.isFn;
      this.leftClick.emit(resultObj);
    } else {
      this.leftClick.emit({
        data: data.node.origin,
        selected: !!data.keys.length,
        node: data.node
      });
    }
  }
  /**
   * 选中事件回调函数
   */
  nzCheck(data: NzFormatEmitEvent): void {
    this.check.emit({
      data: data.node.origin,
      selected: !!data.keys.length,
      node: data.node
    });
  }
  /**
   * 展开回调函数
   */
  expandChangeFn(data: NzFormatEmitEvent) {
    this.expandChange.emit({
      data: data.node.origin,
      expanded: !!data.keys.length,
      node: data.node
    });
  }
  /**
   * 创建右键菜单
   * @param $event 
   * @param menu 
   */
  createContextMenu($event, menu) {
    this.nzContextMenuService.create($event, menu);
  }
}
